const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const DashbaordInforMedias = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "DASHBOARD_INFOR_MEDIAS_REQUEST":
      return { loading: true, error: false, data: [] };
    case "DASHBOARD_INFOR_MEDIAS_ERROR":
      return { loading: false, error: true, data: [] };
    case "DASHBOARD_INFOR_MEDIAS_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "DASHBOARD_INFOR_MEDIAS_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default DashbaordInforMedias;
